class CartDrawer extends HTMLElement {
  constructor() {
    super();

    if (__st.p == "cart") return false;
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.variantSelector  = document.querySelector('variant-selects');
    this.setHeaderCartIconAccessibility();
    document.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE' && this.classList.contains('active')) this.close();
   
    });

    this.cartNoteAccordion = document.querySelector('[data-order-note-title]');
    this.cartNoteAccordionContent = document.querySelector('[data-order-note-content]');

    this.cartNoteAccordion?.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggleCartNoteAccordion();
    });

    // Close cart note accordion when clicking outside
    this._onDocumentClick = this._onDocumentClick?.bind ? this._onDocumentClick.bind(this) : ((event) => this.handleDocumentClick(event));
    document.addEventListener('click', (event) => this.handleDocumentClick(event));
  }

  toggleCartNoteAccordion() {
    this.cartNoteAccordionContent.classList.toggle('open');
  }

  disconnectedCallback() {
    // Best effort cleanup in case element is removed
    document.removeEventListener('click', (event) => this.handleDocumentClick(event));
  }

  handleDocumentClick(event) {
    // Only act when drawer is open and accordion is expanded
    if (!this.classList.contains('active')) return;
    if (!this.cartNoteAccordionContent || !this.cartNoteAccordionContent.classList.contains('open')) return;

    const clickTarget = event.target;
    const clickedInsideContent = this.cartNoteAccordionContent.contains(clickTarget);
    const clickedOnTitle = this.cartNoteAccordion && this.cartNoteAccordion.contains(clickTarget);

    if (!clickedInsideContent && !clickedOnTitle) {
      this.cartNoteAccordionContent.classList.remove('open');
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if(!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    siteOverlay.prototype.showOverlay();
    this.classList.add('active');
    // Utility.trapFocus(triggeredBy);
    Utility.forceFocus(document.querySelector('#CartDrawer'));
    document.body.classList.add('scroll-fixed');
  }

  close() {
    this.classList.remove('active');
    siteOverlay.prototype.hideOverlay();
    // Utility.removeTrapFocus(this.activeElement);
    // Utility.forceFocus(document.querySelector('#cart-icon-bubble'));
    document.body.classList.remove('scroll-fixed');
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    if (parsedState?.sections['cart-drawer'] != null) {
      let cartDrawerHTML = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html').querySelector('[data-cartJSON]')?.innerHTML;
      window.cartStrings.cart = JSON.parse(cartDrawerHTML);
      
      let cartCount = document.querySelector('[data-cart-item-count]');
      if(cartCount) {
        cartCount.innerHTML = window.cartStrings.cart.item_count;
        (window.cartStrings.cart.item_count > 0) ? cartCount.closest('.cart-count-bubble').style.display = '' : cartCount.closest('.cart-count-bubble').style.display = 'none';
      }
    }
    
    if(this.variantSelector) this.variantSelector.updateQtyNumbers(parsedState.id);

    setTimeout(() => {
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
